import React, { useEffect, useState } from 'react';
import './Land.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import TAMILNADUMAP from '../images/TAMILNADUMAP.png'; // Adjust path as necessary
import Topbar from './Topbar';
import LANDPURCHASE from '../images/LANDPURCHASE.jpeg';
import LANDHEROSEC from '../images/LANDHEROSEC.jpg'; 
import LANDSALE from '../images/LANDSALE.avif'; 
import Reviews from './Reviews';
import Rating from './Rating';
import Upload from './Upload';













export default function Land() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };

  return (
    <div>
      <div><Topbar/></div>
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${LANDHEROSEC})` }}>
        <div className="hero-content">
          <h1>APPOLLO AGENCY</h1>
          <p>PURCHSE, SALE, RENT, LEASE</p>
          <a href="tel:+919884226561" className="hero-btn">Book Service?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              <p>Welcome to Apollo Agency! With over 32 years of dedicated experience in the real estate industry, we are proud to be your trusted partner for all land-related needs. Whether you're looking to purchase, sell, or lease land, our unmatched expertise ensures a seamless experience tailored to your goals.

We understand the importance of finding the perfect piece of land—whether it’s for building your dream home, starting a business, or making a valuable investment. At Apollo Agency, we are committed to guiding you every step of the way, providing clarity and confidence throughout the process.

Transparency is the cornerstone of our services. We believe trust forms the foundation of our relationship with you, which is why we provide clear and comprehensive information at every stage. Our seasoned team delivers market insights, legal guidance, and personalized solutions to help you make well-informed decisions about your property.

Customer satisfaction is our top priority. With timely, reliable, and professional assistance, we ensure that your land transactions are smooth and stress-free. Whether you're a buyer, seller, or lessor, Apollo Agency is here to provide unparalleled service, turning your property aspirations into reality.

Let our 32 years of experience help you make the most of your land opportunities today!</p>
            </div>
          </div>
        </div>
      </section>



      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<h2>Purchase | Sale | Rent | Lease</h2>


</div>

</div>

</div>
</section>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<img src={TAMILNADUMAP} alt="Gallery Image 1" className="img-fluid rounded" />

</div>
<h5>Tamil Nadu</h5>
</div>

</div>
</section>




      <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={LANDPURCHASE} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>LAND PURCHASE</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency, we specialize in reliable and efficient land purchase and real estate services to help you secure the perfect property for your needs. Our experienced team has expertise in handling all types of land transactions, whether you're looking for residential plots, commercial spaces, or agricultural lands.

With over 32 years of trusted service, we are committed to providing transparent processes and fair pricing, ensuring your peace of mind at every step. From site selection and market analysis to legal documentation and negotiation, we handle every detail with professionalism and care.

At Apollo Agency, our goal is to deliver high-quality, timely service you can depend on, making your land purchase journey seamless and stress-free. Let us help you find the ideal property that aligns with your vision and investment goals.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={LANDSALE} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>LAND SALE</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency specializes in land sale services, offering a seamless and transparent experience to help you secure the perfect property. With over 32 years of expertise, we handle all types of land transactions, whether you’re selling residential, commercial, or agricultural plots, across various prime locations.

Our experienced professionals provide accurate market analysis to determine the best value for your property. We prioritize transparency, ensuring clear negotiations and handling all legal documentation to make the process smooth and stress-free. At Apollo Agency, we understand the significance of your investment and are dedicated to delivering timely and efficient service.

Choose Apollo Agency to sell your land with confidence. Our trusted team will guide you every step of the way, connecting you with the right buyers and ensuring you achieve competitive prices. Let us help you maximize the value of your land while ensuring a hassle-free experience from start to finish.</p>
    </div>
  </div>

</section>


<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-trophy"></i>
        <h3>Proven Expertise</h3>
        <p>Over a decade of experience delivering top-notch services to clients.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-user-check"></i>
        <h3>Customer Satisfaction</h3>
        <p>Our clients are our priority, and we go the extra mile to meet their needs.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-chart-line"></i>
        <h3>Results-Driven</h3>
        <p>We focus on achieving measurable outcomes for your success.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-headset"></i>
        <h3>24/7 Support</h3>
        <p>Our team is available around the clock to assist with any concerns.</p>
      </div>
    </div>
  </div>
</section>








<div><Reviews/></div>



{/* Other sections */}
<section id="faq-land">
  <div className="container">
    <h2>FAQs - Frequently Asked Questions</h2>
    <div className="accordion">
      {[
        {
          question: "How can Apollo Agency assist with land purchases?",
          answer: "We provide comprehensive support, from identifying suitable plots to legal documentation and registration.",
        },
        {
          question: "Do you offer services for land leasing?",
          answer: "Yes, we facilitate land leasing, including contract preparation and tenant verification.",
        },
        {
          question: "Can Apollo Agency help with land sales?",
          answer: "Absolutely, we assist in marketing your land, finding potential buyers, and negotiating the best deals.",
        },
        {
          question: "What kind of lands do you deal with?",
          answer: "We specialize in residential plots, agricultural land, commercial land, and industrial spaces.",
        },
        {
          question: "Why should I trust Apollo Agency for land services?",
          answer: "With years of experience, transparency, and a customer-centric approach, we ensure reliable and hassle-free transactions.",
        },
        {
          question: "Do you offer valuation services for land?",
          answer: "Yes, we provide expert valuation services to help you determine the current market value of your property.",
        },
      ].map((faq, index) => (
        <div className="accordion-item" key={index}>
          <div className="accordion-header" onClick={() => toggleFaq(index)}>
            <h3>{faq.question}</h3>
            <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
          </div>
          <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>




<section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>13.A, Sudhanadha Bharathi St.,</p>
      <p>East Tambaram, Chennai-600059</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +919884226561<br/>Email: info.appolloagency@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
        <a href="https://www.google.com/maps?q=Chennai" target="_blank">View on Google Maps</a>
      </p>
    </div>
  </div>
</section>


      <section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>





<div>
  <Rating />
</div>
{/* <div><Upload/></div> */}
    
    <div><Footer /></div>
  </div>
  </div>
  )
}
